/* Prompted cart progress integration; separate from Dawn cart contracts. */
window.TCSCartProgress = {
  update(cartTotal, itemCount) {
    document.querySelectorAll("[id=cart-progress-wrapper]").forEach((progressWrapper) => {

    const currencyFormat = progressWrapper.dataset.currencyFormat;
    const progressThreshold = parseInt(progressWrapper.dataset.threshold, 10);
    if (!Number.isFinite(progressThreshold) || progressThreshold <= 0) {
      progressWrapper.hidden = true;
      return;
    }
    const preGoalMessageTemplate =
      progressWrapper.dataset.preGoalMessageTemplate;
    const postGoalMessage = progressWrapper.dataset.postGoalMessage;

    const progressBar = progressWrapper.querySelector("[id=cart-progress-bar]");
    const goalMessageElement = progressWrapper.querySelector(".goal-message");

    if (itemCount === 0 || cartTotal === 0) {
      if (progressWrapper) {
        progressWrapper.style.display = "none";
      }
      if (goalMessageElement) {
        goalMessageElement.style.display = "none";
      }
    } else {
      if (progressWrapper) {
        progressWrapper.style.display = "block";
      }
      if (progressBar) {
        progressBar.style.display = "block";
        const progressPercentage = Math.min(
          (cartTotal / progressThreshold) * 100,
          100
        );
        progressBar.style.width = `${progressPercentage}%`;

        if (progressPercentage >= 100) {
          progressWrapper.classList.add("full");
        } else {
          progressWrapper.classList.remove("full");
        }
      }

      if (goalMessageElement) {
        goalMessageElement.style.display = "block";
        let remainingForGoal = progressThreshold - cartTotal;

        if (remainingForGoal < 0) {
          remainingForGoal = 0;
        }

        const remainingAmount = remainingForGoal / 100;
        const remainingAmountFormatted = window.TCSCartProgress.formatCurrency(
          currencyFormat,
          remainingAmount
        );
        const preGoalMessage = preGoalMessageTemplate.replace(
          "[remaining_for_goal]",
          remainingAmountFormatted
        );

        goalMessageElement.innerHTML =
          remainingForGoal > 0 ? preGoalMessage : postGoalMessage;
      }
    }
    });
  },
  formatCurrency(currencyFormat, amount) {
    let formattedAmount = "";
    formattedAmount = currencyFormat
      .replace("{{amount}}", amount.toFixed(2)) // Standard with two decimals
      .replace("{{amount_no_decimals}}", amount.toFixed(0)) // No decimals
      .replace(
        "{{amount_with_comma_separator}}",
        amount.toFixed(2).replace(".", ",")
      ) // Replace period with comma
      .replace(
        "{{amount_no_decimals_with_comma_separator}}",
        amount.toFixed(0).replace(".", ",")
      ) // No decimals, use comma
      .replace(
        "{{amount_with_apostrophe_separator}}",
        amount.toFixed(2).replace(".", "'")
      ) // Apostrophe separator
      .replace(
        "{{amount_no_decimals_with_space_separator}}",
        amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      ) // No decimals, space
      .replace(
        "{{amount_with_space_separator}}",
        amount
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
          .replace(".", ",")
      ) // Space separator
      .replace(
        "{{amount_with_period_and_space_separator}}",
        amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      ); // Period and space
    return formattedAmount;
  }


};
